<template>
  <Mobile
    :region="mainStore.region as ISimpleRegion"
    :year="year"
    :years="mainStore.awardYears"
    :breadcrumbs="breadcrumbs"
  />
</template>

<script setup lang="ts">
import type { IBreadcrumb, ISimpleRegion } from '~/types'
import Mobile from '~/features/city/Mobile.vue'
import { AWARD_ROUTE_NAMES } from '~/features/Home/constants'

definePageMeta({
  middleware: [(to) => {
    // Если пытаются перейти именно на эту страницу /awards/year/results/city/ (без doctors или lpus)
    // Редирект на /awards/year/results/city/doctors
    if (to.name === AWARD_ROUTE_NAMES.town) {
      return navigateTo({
        name: AWARD_ROUTE_NAMES.doctor,
        params: { year: to.params.year },
      })
    }
  }, 'fetch-region'],
})

const $route = useRoute()
const mainStore = useMainStore()

const title = `Всероссийская премия ПроДокторов ${$route.params.year} - результаты премии в ${mainStore.region?.prepositional_form}`
const description = `Результаты премии ПроДокторов в ${mainStore.region?.prepositional_form} по отзывам за ${$route.params.year} год`

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: `/meta/og-awards-${$route.params.year}.png`,
  ogUrl: useRuntimeConfig().public.awardUrl + $route.fullPath,
})

const year = computed(() => Number($route.params.year))
const breadcrumbs = computed<IBreadcrumb[]>(() => [{ title: mainStore.region?.name || '' }])
</script>
